export const extractPreviewBodyHtml = (iframe) => {
  const doc = iframe?.contentDocument;
  if (!doc?.body) return "";
  return doc.body.innerHTML;
};

export const enableEditableMailPreview = (iframe, onHtmlChange) => {
  const doc = iframe?.contentDocument;
  if (!doc?.body) return undefined;

  doc.body.contentEditable = "true";
  doc.body.style.outline = "none";
  doc.body.style.minHeight = "480px";
  doc.body.style.cursor = "text";

  const handleInput = () => {
    if (typeof onHtmlChange === "function") {
      onHtmlChange(extractPreviewBodyHtml(iframe));
    }
  };

  doc.body.addEventListener("input", handleInput);
  return () => {
    doc.body.removeEventListener("input", handleInput);
  };
};
